"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const menuButtons_1 = require("../models/menuButtons");
class NatureProduit extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "natureProduit",
            datatableName: "natureProduitdatatable",
            columns: [
                { id: "unid", header: (0, globals_1._)("N°"), width: 40, css: { "text-align": "right" }, sort: "int" },
                // {id: "code", header: _("Code"), width: 40, css: {"text-align": "right"}, sort: "int"},
                { id: "libelle", editor: "text", header: (0, globals_1._)("Libellé"), width: 120, sort: "text", maxlength: 16 },
                // {id: "tauxTva",  header: _("Taux de TVA"), width: 120, sort: "int", maxlength: 6},
                { id: "compteVente", editor: "text", header: (0, globals_1._)("Compte vente"), width: 140, maxlength: 12 },
                { id: "designationCompteVente", editor: "text", header: (0, globals_1._)("Désignation compte"), width: 400, maxlength: 48 }
            ],
            title: (0, globals_1._)("Nature des produits"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.supprimerButton],
            resizeColumn: true,
            urlData: globals_1.phpPath + "natureProduit.php?option=list",
            saveData: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "natureProduit.php?option=insertEmpty",
                "update": globals_1.phpPath + "natureProduit.php?option=update",
                "delete": globals_1.phpPath + "natureProduit.php?option=delete",
            },
            tname: "tname=parametres",
        });
    }
    ready() {
        this.currentGrid = $$(this.datatableName);
        let me = this;
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
            }
        });
        menu.hideMenuItem("button-add"); // Obligatoire depuis la version 10.0, la propriété hidden ne marche plus
        menu.hideMenuItem("button-del");
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insertEmpty,")) {
            menu.showMenuItem("button-add");
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) {
            menu.showMenuItem("button-del");
        }
    }
}
exports.default = NatureProduit;
